const merchant = {
  merchantId: '1459636',
  secretKey: 'yJYpZDjPKbBU84bYzlJLYJiYueECHuoh',
  currency: 'UAH',
}

export default merchant
